import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-the-page-f01 c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "c-common-inner p-the-page-f01__inner" }
const _hoisted_5 = { class: "p-the-page-f01__body" }
const _hoisted_6 = { class: "p-the-page-f01__content" }
const _hoisted_7 = {
  key: 0,
  class: "p-the-page-f01__items"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheBreadcrumb = _resolveComponent("TheBreadcrumb")!
  const _component_ItemListPanelLarge = _resolveComponent("ItemListPanelLarge")!
  const _component_ItemEmptyPanel = _resolveComponent("ItemEmptyPanel")!
  const _component_ItemCarouselGroup = _resolveComponent("ItemCarouselGroup")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheHeader, { ref: "theHeader" }, null, 512),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TheBreadcrumb)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "p-the-page-f01__heading" }, "閲覧履歴", -1)),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.itemListData.length > 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemListData, (item, key) => {
                    return (_openBlock(), _createBlock(_component_ItemListPanelLarge, {
                      id: item.id,
                      key: key,
                      page: _ctx.page,
                      thumbnails: item.thumbnails,
                      status: item.status,
                      name: item.name,
                      point: item.point,
                      "discount-rate": item.discount_rate,
                      "is-cart": item.is_cart,
                      stock: item.stock,
                      "stock-control": item.is_quantity_control,
                      type: item.type,
                      color: item.colorCode,
                      "supplier-creditcard": item.supplier_creditcard,
                      "used-points-after-add-to-cart": _ctx.usedPointsAfterAddToCart,
                      "premium-id": item.premium_id,
                      options: item.options,
                      "age-alert": item.is_age_alert,
                      onDelete: ($event: any) => (_ctx.onDelete(item.bh_id))
                    }, null, 8, ["id", "page", "thumbnails", "status", "name", "point", "discount-rate", "is-cart", "stock", "stock-control", "type", "color", "supplier-creditcard", "used-points-after-add-to-cart", "premium-id", "options", "age-alert", "onDelete"]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock(_component_ItemEmptyPanel, {
                  key: 1,
                  text: "アイテムの閲覧履歴はありません。",
                  type: "history"
                }))
          ]),
          _createVNode(_component_ItemCarouselGroup, {
            histories: _ctx.histories,
            recommendations: _ctx.recommendations,
            favorites: _ctx.favorites
          }, null, 8, ["histories", "recommendations", "favorites"])
        ])
      ])
    ]),
    _createVNode(_component_TheFooter)
  ]))
}